import TreatmentPriceLink from "@/pages/treatment/components/TreatmentPriceLink";
import type { SkinDetailPrice as SkinDetailPriceData } from "@/mocks/skinTreatmentDetails";

/**
 * お肌管理 個別施術ページの料金表示。
 * 公式サイトでは「1回の定価」を表示する（複数回コースはWeb非掲載）。
 * PC: 表形式 / スマホ: 対象ごとの縦ブロック。
 */
export default function SkinDetailPrice({
  price,
  note,
}: {
  price?: SkinDetailPriceData;
  note?: string;
}) {
  return (
    <div className="space-y-8">
      {note ? (
        <p className="max-w-3xl border-l-2 border-accent-500 pl-4 text-[13px] leading-[2.1] text-foreground-700">
          {note}
        </p>
      ) : null}

      {price ? (
        <>
          {/* PC: 表形式 */}
          <div className="hidden md:block">
            <div className="grid grid-cols-[1.6fr_1fr] border-t border-foreground-950/20 pb-3 pt-4 text-[11px] tracking-[0.15em] text-foreground-500">
              <span>対象</span>
              <span className="text-right">料金</span>
            </div>
            {price.rows.map((row) => (
              <div
                key={row.label}
                className="grid grid-cols-[1.6fr_1fr] items-baseline border-t border-foreground-950/12 py-5"
              >
                <span className="pr-6 font-heading text-[15px] text-foreground-950">{row.label}</span>
                <span className="text-right font-label text-[15px] text-foreground-900">{row.price}</span>
              </div>
            ))}
          </div>

          {/* スマホ: 対象ごとの縦ブロック */}
          <div className="space-y-3 md:hidden">
            {price.rows.map((row) => (
              <div key={`${row.label}-sp`} className="border border-foreground-950/12 bg-background-50 p-5">
                <span className="font-heading text-[16px] text-foreground-950">{row.label}</span>
                <div className="mt-4 flex items-center justify-between border-t border-foreground-950/10 pt-4">
                  <span className="text-[12.5px] text-foreground-600">料金</span>
                  <span className="font-label text-[15px] text-foreground-900">{row.price}</span>
                </div>
              </div>
            ))}
          </div>

          <p className="text-[11.5px] leading-[2] text-foreground-500">表示価格はすべて税込です。</p>
        </>
      ) : null}

      <div className="mt-8">
        <TreatmentPriceLink categoryId="skin" categoryJp="お肌管理" />
      </div>
    </div>
  );
}